// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"624":"clere","738":"course-manager"}[chunkId] || chunkId) + "." + {"354":"024f89c5","368":"1fb80c43","445":"ccc43ad4","624":"71527596","668":"4c2bc80f","738":"e4c70bc6","838":"3787910e"}[chunkId] + ".js";
};